import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo/logo-w.svg'


const _withScopeId = n => (_pushScopeId("data-v-baaa71de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "navigation__brand" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "We Run football"
}, null, -1))
const _hoisted_4 = { class: "navigation__action" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "navigation__list-close" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Organizacije ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Radna ploča ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Utakmice ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Treninzi ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Dijagnostika ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Zdravlje ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Igrači ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Resursi ", -1))
const _hoisted_21 = { class: "navigation__list-additional-action" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navigation__list-decoration" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "We Run football"
  })
], -1))
const _hoisted_23 = { class: "navigation__additional-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_DataBoard = _resolveComponent("DataBoard")!
  const _component_Football = _resolveComponent("Football")!
  const _component_DataLine = _resolveComponent("DataLine")!
  const _component_DataAnalysis = _resolveComponent("DataAnalysis")!
  const _component_FirstAidKit = _resolveComponent("FirstAidKit")!
  const _component_User = _resolveComponent("User")!
  const _component_FolderOpened = _resolveComponent("FolderOpened")!
  const _component_SwitchOrganizationIndexVue = _resolveComponent("SwitchOrganizationIndexVue")!
  const _component_AuthenticationLogoutIndexVue = _resolveComponent("AuthenticationLogoutIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'AppAdministratorDashboardRootIndexVue' } }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isNavigationListVisible = true), ["prevent"]))
      }, _hoisted_8)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["navigation__list", { 'is-visible': _ctx.isNavigationListVisible }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isNavigationListVisible = false), ["prevent"]))
        }, _hoisted_12)
      ]),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: { name: 'AppAdministratorOrganizationsRootIndexVue' },
            class: _normalizeClass({ 'router-link-exact-active': _ctx.exactRoute === 'organizations' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_OfficeBuilding),
              _hoisted_13
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: { name: 'AppAdministratorDashboardRootIndexVue' },
            class: _normalizeClass({ 'router-link-exact-active': _ctx.exactRoute === 'dashboard' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DataBoard),
              _hoisted_14
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: { name: 'AppAdministratorMatchesRootIndexVue' },
            class: _normalizeClass({ 'router-link-exact-active': _ctx.exactRoute === 'matches' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Football),
              _hoisted_15
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: { name: 'AppAdministratorTrainingsRootIndexVue' },
            class: _normalizeClass({ 'router-link-exact-active': _ctx.exactRoute === 'trainings' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DataLine),
              _hoisted_16
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: { name: 'AppAdministratorDiagnosticsRootIndexVue' },
            class: _normalizeClass({ 'router-link-exact-active': _ctx.exactRoute === 'diagnostics' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DataAnalysis),
              _hoisted_17
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: { name: 'AppAdministratorHealthRecordsRootIndexVue' },
            class: _normalizeClass({ 'router-link-exact-active': _ctx.exactRoute === 'health-records' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FirstAidKit),
              _hoisted_18
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: { name: 'AppAdministratorPlayersRootIndexVue' },
            class: _normalizeClass({ 'router-link-exact-active': _ctx.exactRoute === 'players' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_User),
              _hoisted_19
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: { name: 'AppAdministratorResourcesRootIndexVue' },
            class: _normalizeClass({ 'router-link-exact-active': _ctx.exactRoute === 'resources' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FolderOpened),
              _hoisted_20
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_ctx.hasUserOrganizationMemberships)
          ? (_openBlock(), _createBlock(_component_SwitchOrganizationIndexVue, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_AuthenticationLogoutIndexVue)
      ]),
      _hoisted_22
    ], 2),
    _createElementVNode("div", _hoisted_23, [
      (_ctx.hasUserOrganizationMemberships)
        ? (_openBlock(), _createBlock(_component_SwitchOrganizationIndexVue, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_AuthenticationLogoutIndexVue)
    ])
  ]))
}